import { env } from '../config';
import * as Events from './events';
import { DevAnalytics } from './model';
import type { AnalyticsEvent, AppAnalytics } from './types';

export { WebAnalytics, WebviewAnalytics } from './model';
export const AnalyticsEvents = Events;

let instance: AppAnalytics = new DevAnalytics();

/**
 * @description Code imports Analytics directly from this file, so we need to keep public API
 *
 * TODO: Provide analytics via injection or any other top level way and remove direct imports
 */
export const Analytics = {
  setup(analyticsInstance: AppAnalytics) {
    /**
     * @description We need to use real analytics in staging and production env.
     * In dev we should use DevAnalytics
     */
    if (env.MODE !== 'development') {
      instance = analyticsInstance;
    }
  },
  logEvent(event: AnalyticsEvent) {
    instance.logEvent(event);
  },
};
